module.exports = __webpack_public_path__ + "static/media/03.c7617e63.png";